import React, { Component } from 'react';
import Header from './components/header';
import BookList from './components/bookList';
import Books from './services/books';
import Pagination from './components/pagination';
import './css/flexboxgrid.css';
import './css/App.css';

class App extends Component {
  state = {
    keyword: '',
    books: [],
    totalItems: 0,
    currentPage: 1,
    itemsPerPage: 40,
    startIndex: 0,
    booksImported: [],
    booksBeingImported: []
  };

  async findBooks() {
    const startIndex = (this.state.currentPage - 1) * this.state.itemsPerPage;
    let {
      data: { items: books, totalItems }
    } = await Books.search(
      this.state.keyword,
      this.state.itemsPerPage,
      startIndex
    );
    books = books ? books : [];
    const booksMapped = Books.mapSearchResults(books);
    this.setState({ books: booksMapped, totalItems });
  }

  handleKeywordChange = ({ currentTarget: { value } }) => {
    this.setState({ keyword: value });
  };

  handleKeywordSubmit = e => {
    this.findBooks();
    this.setState({ currentPage: 1 });
    e.preventDefault();
  };

  handlePageChange = (page, e) => {
    this.setState({ currentPage: page });
    this.findBooks();
    e.preventDefault();
  };

  handleBookImport = async item => {
    // add to temporary importing book list
    const booksBeingImported = this.state.booksBeingImported;
    booksBeingImported.push(item.id);
    this.setState({ booksBeingImported });

    // run import
    await Books.insert(item.id);

    // remove from temporary importing book list
    let newBooksBeingImportedList = this.state.booksBeingImported;
    newBooksBeingImportedList = newBooksBeingImportedList.filter(
      id => id !== item.id
    );
    this.setState({ booksBeingImported: newBooksBeingImportedList });

    // add to permanently imported list
    const booksImported = this.state.booksImported;
    booksImported.push(item.id);
    this.setState({ booksImported });
  };

  render() {
    const {
      keyword,
      books,
      totalItems,
      itemsPerPage,
      currentPage,
      booksBeingImported,
      booksImported
    } = this.state;

    return (
      <div className="gb-main">
        <Header
          keyword={keyword}
          handleChange={this.handleKeywordChange}
          handleSubmit={this.handleKeywordSubmit}
        />
        <BookList
          books={books}
          handleBookImport={this.handleBookImport}
          booksBeingImported={booksBeingImported}
          booksImported={booksImported}
        />
        <Pagination
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={this.handlePageChange}
        />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js